import React, { useEffect, useRef } from 'react';
import classnames from 'classnames/bind';
import { Collapsible } from 'taboola-ultimate-ui';
import { useChatAgentPermitted } from 'components/ChatAgent/hooks/useChatAgentPermitted';
import {
    COLLAPSED_WIDTH,
    EXPANDED_WIDTH as EXPANDED_WIDTH_WITH_PADDING,
} from 'modules/taboola-common-frontend-modules/chat-agent/config/chatAgentSideBarConfig';
import { useChatAgentContext } from 'modules/taboola-common-frontend-modules/chat-agent/hooks/useChatAgentContext';
import { useModuleName } from '../../hooks';
import { MODULE_NAME } from '../../modules/onboarding';
import { ChatDevTool } from '../ChatAgent/components/ChatAgentDevTool/ChatDevTool';
import { ChatAgentSidebarChatContainer } from './components/ChatAgentSidebarChatContainer/ChatAgentSidebarChatContainer';
import styles from './chatAgentSideBar.module.scss';

const classNameBuilder = classnames.bind(styles);

const transitionDuration = 1000 * Number.parseFloat(styles.animationTime);

const PADDING_LEFT = Number.parseInt(styles.paddingLeft);
const EXPANDED_WIDTH = EXPANDED_WIDTH_WITH_PADDING - PADDING_LEFT;

export const ChatAgentSideBar = () => {
    const moduleName = useModuleName();
    const isOnboardingModule = moduleName === MODULE_NAME;
    const { isCollapsed: collapsed, closeChat, initializeChat, isChatOpened } = useChatAgentContext();
    const isPermitted = useChatAgentPermitted();
    const chatContainerRef = useRef();
    const chatKitContainerRef = useRef();
    const allContainersRendered = !!chatContainerRef.current && !!chatKitContainerRef.current;

    useEffect(() => {
        if (allContainersRendered && !isChatOpened) {
            initializeChat({
                container: chatContainerRef.current,
                chatKitContainer: chatKitContainerRef.current,
            });
        }
    }, [allContainersRendered, initializeChat, isChatOpened]);

    if (!isPermitted || isOnboardingModule) {
        return null;
    }

    return (
        <div className={classNameBuilder('chat-agent-side-bar-container', { collapsed })}>
            <Collapsible
                collapsed={collapsed}
                direction={Collapsible.DIRECTION.HORIZONTAL}
                collapsedSize={COLLAPSED_WIDTH}
                expandedSize={EXPANDED_WIDTH}
                className={styles['collapsible']}
                transitionDuration={transitionDuration}
            >
                <div className={styles['collapsible-content']} style={{ width: EXPANDED_WIDTH }}>
                    <ChatAgentSidebarChatContainer
                        chatContainerRef={chatContainerRef}
                        chatKitContainerRef={chatKitContainerRef}
                        closeChat={closeChat}
                    />
                    <ChatDevTool />
                </div>
            </Collapsible>
        </div>
    );
};
